module.exports = __webpack_public_path__ + "static/media/downarrow.98166ea4.svg";